var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEvents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 29.326,
    viewBox: "1217.5 416.837 30 29.326",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 5",
    transform: "translate(1943 -623)",
    clipPath: "url(\"#a\")"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Union 4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-721.614 1069.163a3.884 3.884 0 0 1-3.886-3.89v-18.668a3.89 3.89 0 0 1 3.886-3.89h1.982v-2.1a.778.778 0 1 1 1.554 0v2.1h15.156v-2.1a.778.778 0 1 1 1.554 0v2.1h1.982a3.89 3.89 0 0 1 3.886 3.89v18.669a3.89 3.89 0 0 1-3.886 3.89h-22.228Zm-2.332-3.89a2.335 2.335 0 0 0 2.332 2.334h22.228a2.33 2.33 0 0 0 2.331-2.333v-14.236h-26.89v14.236Zm.684-20.319a2.335 2.335 0 0 0-.683 1.65v2.879h26.89v-2.878a2.335 2.335 0 0 0-2.33-2.334h-1.983v1.478a.777.777 0 1 1-1.554 0v-1.478h-15.156v1.478a.777.777 0 1 1-1.554 0v-1.478h-1.981a2.33 2.33 0 0 0-1.65.683Zm10.47 18.142-3.576-3.695a.778.778 0 0 1 1.088-1.09l3.11 3.151 6.916-6.106a.816.816 0 0 1 1.127.039.856.856 0 0 1-.078 1.128l-7.5 6.612a.934.934 0 0 1-.532.195.777.777 0 0 1-.556-.234Z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-721.614 1069.163a3.884 3.884 0 0 1-3.886-3.89v-18.668a3.89 3.89 0 0 1 3.886-3.89h1.982v-2.1a.778.778 0 1 1 1.554 0v2.1h15.156v-2.1a.778.778 0 1 1 1.554 0v2.1h1.982a3.89 3.89 0 0 1 3.886 3.89v18.669a3.89 3.89 0 0 1-3.886 3.89h-22.228Zm-2.332-3.89a2.335 2.335 0 0 0 2.332 2.334h22.228a2.33 2.33 0 0 0 2.331-2.333v-14.236h-26.89v14.236Zm.684-20.319a2.335 2.335 0 0 0-.683 1.65v2.879h26.89v-2.878a2.335 2.335 0 0 0-2.33-2.334h-1.983v1.478a.777.777 0 1 1-1.554 0v-1.478h-15.156v1.478a.777.777 0 1 1-1.554 0v-1.478h-1.981a2.33 2.33 0 0 0-1.65.683Zm10.47 18.142h0l-3.576-3.695a.778.778 0 0 1 1.088-1.09l3.11 3.151 6.916-6.106h0a.816.816 0 0 1 1.127.039.856.856 0 0 1-.078 1.128l-7.5 6.612a.934.934 0 0 1-.532.195.777.777 0 0 1-.556-.234Z",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    stroke: "#e4e4e4",
    fill: "transparent"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0V0z",
    "data-name": "Rectangle 259",
    transform: "translate(-725 1040)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvents);
export default __webpack_public_path__ + "static/media/events.142a4c3bd8f5ae0c1cf2c95a33e9dcfc.svg";
export { ForwardRef as ReactComponent };